import React from 'react'
import Image from '../imgix-img'
import { getValue } from '../../utils/product-schema'

const ProductDetails = ({ productData, schema }) => {
  return (
    <div className='ProductDetails'>
      <h3 className='ProductDetails__title'>{getValue(schema.title, productData)}</h3>
      <Image
        src={getValue(schema.image, productData)}
        width={180}
        height={66}
        critical={false}
        alt={'Zempler Logo'}
      />
      <div className='ProductDetails__details'>
        {schema.details.map((d, key) => {
          const label = getValue(d.label, productData)
          const value = getValue(d.value, productData)
          return (
            <div key={key} className='ProductDetails__details__detail'>
              <div>{label}</div>
              <div className='ProductDetails__details__value'>{value}</div>
            </div>
          )
        })}
        {schema.footer && (
          <div className='ProductDetails__details__detail'>
            {schema.footer.label}
            {getValue(schema.footer.text, productData)}
          </div>
        )}
      </div>
      {schema.extras && (
        <details>
          <summary data-open='Show less fees' data-close='Show all fees' />
          <div className='ProductDetails__details'>
            {schema.extras.items.map((d, key) => {
              const label = getValue(d.label, productData)
              const value = getValue(d.value, productData)
              return (
                <div key={key} className='ProductDetails__details__extra'>
                  <div>{label}</div>
                  <div className='ProductDetails__details__value'>{value}</div>
                </div>
              )
            })}
          </div>
        </details>
      )}
      <div className='ProductDetails__usps'>
        <h4>{getValue(schema.usps.title, productData)}</h4>
        <ul>
          {schema.usps.items.map((i, key) => {
            return <li key={key}>{getValue(i, productData)}</li>
          })}
        </ul>
      </div>
    </div>
  )
}

export default ProductDetails
